import React from 'react'

const PaginationNext = (props) => (
  <svg width="8" height="14" viewBox="0 0 8 14" fill="#1D79FB" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.70132 13.0104L7.71173 7.00003L1.70133 0.989624L0.287112 2.40384L4.8833 7.00003L0.287109 11.5962L1.70132 13.0104Z"
          />
  </svg>
)

export default PaginationNext
